export const downloadURI = (uri: string, name?: string) => {
  const link = document.createElement('a');
  if (name) link.download = name;
  link.href = uri;
  link.click();
};
